import { api } from 'utils';

export interface InsuredEmployeesByMonthData {
  month: string;
  label: string;
  count: number;
}

export interface InsuredEmployeesByMonthResponse {
  success: boolean;
  data: InsuredEmployeesByMonthData[];
}

export function fetchInsuredEmployeesByMonthApi() {
  return api().get<InsuredEmployeesByMonthResponse>(
    '/list/three/statistics/by-month'
  );
}
